<template>  
  <div>
		<v-layout>
			<v-flex md6>
        <h3>Perfiles</h3>
			</v-flex>
			<v-flex md6>
        <v-btn color="primary" @click="addItem" class="float-r">
          <v-icon>add</v-icon>
          <span>Agregar Perfil</span>
        </v-btn>
			</v-flex>
		</v-layout>

		<v-layout>
			<v-flex md12>
        <v-data-table
			    hide-default-footer
          :headers="headers"
          :items="rows"
          item-key="id"
          class="tablaT1"
          :class="dark_t?'dark':''">
          <template v-slot:item="props">
            <tr>
              <td :style="`background-color:${dark_t?'black':'white'}`">
                <v-icon @click="askForDelete(props.item)" style="color:darkred">delete</v-icon>
              </td>
              <td style="text-align:left !important">
                <fs1-span>{{props.item.name}}</fs1-span>
              </td>
              <td style="text-align:left !important">
                <fs1-span>{{permissionsNames(props.item.permissions)}}</fs1-span>
              </td>
              <td :style="`background-color:${dark_t?'black':'white'}`">
                <v-icon @click="selectedItem = {...props.item}; dialog = true">edit</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
			</v-flex>
		</v-layout>

		<v-dialog v-model="dialog" width="600">
			<v-card class="pa-40 textAlignCenter">
				<h3>Perfil</h3>
				<div class="mt-40">
          <v-text-field placeholder="Nombre del perfil"
            clearable
            prepend-icon="edit" 
            :class="!selectedItem.name && 'textEmpty'"
            v-model="selectedItem.name"/>
				</div>
				<div class="mt-20">
          <div class="checkBoxContainer">
            <v-checkbox v-for="(v, i) in permissions" :key="i"
              hide-details
              v-model="selectedItem.permissions" :label="v.name" :value="v.id"/>
          </div>
				</div>
				<br>
				<div>
					<v-btn color="secondary" @click="dialog = false">
						<v-icon>close</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="save">
						<v-icon class="mr-1">save</v-icon>
						<span>Guardar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>
		<v-dialog persistent v-model="deleteDialog" width="400">
			<v-card class="pa-20 textAlignCenter">
				<h3>¿Seguro desea eliminar el perfil "{{selectedItem.name}}"?</h3>
        <h5>usuarios podrian quedar sin acceso a la plataforma?</h5>
				<br>
				<div>
					<v-btn color="secondary" @click="deleteDialog = false">
						<v-icon>reply</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="deleteItem(selectedItem)">
						<v-icon>delete</v-icon>
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>
  </div>	
</template>

<script>
import { mapGetters } from 'vuex';
import { addProfiles, editProfile, addPermissions } from '@/requests/ac';
import SimpleCrud from '@/components/mixins/simpleCrud/SimpleCrud';
export default {
  mixins: [SimpleCrud],
  data() {
    return {
      storeKey: 'profiles'
    };
  },
  computed: {
    ...mapGetters({
      profiles: 'profiles',
      permissions: 'permissions',
    }),
    add() { return addProfiles },
    edit() { return editProfile },
    defaultItem() { return JSON.parse(JSON.stringify({name: '', permissions: []}))},
    headers() {
      return [
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
				{ text: 'Nombre', sortable: false, value: 'name', class: 'width200px' },
				{ text: 'Permisos', sortable: false, value: 'value' },
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
      ];
		},
  },
  methods: {
    permissionsNames(permissions) {
      let res = this.permissions.filter(p => permissions.includes(p.id));
      res = res.map(r => r.name);
      return res.join(', ');
    },
    async aaa() {
/* 
[
'Ver Dashboard',
'Solicitar Activo Crítico',
'Solicitar Repuesto Importante o Crítico',
  'Aprobar Activo Crítico',
  'Aprobar Repuesto Importante o Repuesto Crítico',
'Ver todas las solicitudes realizadas dentro de la plataforma',
'Subir reportes de Auditoria',
'Actualizar valores de EBIT',
  'Crear usuarios',
'Cambiar perfil de usuarios'
].forEach(async name => {
  await addPermissions({name})
}) */

/* [
'Exportar excel de Activos criticos',
'Exportar excel de Repuestos criticos'
].forEach(async name => {
  await addPermissions({name})
}) */
    },
  },
};
</script>

<style scoped>
  .checkBoxContainer>.v-input{
    margin: 0;
  }
</style>